import { createContext, useContext } from 'react';

const MaximumTileTextLength = /*#__PURE__*/createContext(0);
function useMaximumTileTextLength() {
  return useContext(MaximumTileTextLength);
}

export { MaximumTileTextLength, useMaximumTileTextLength };
//# sourceMappingURL=context.js.map
